import * as organizationsWorkspacesCommands from '@Organizations/Workspaces/commands-vue-composables'
import * as organizationsWorkspacesQueries from '@Organizations/Workspaces/queries-vue-composables'

export function useAdminEditWorkspacePage(){
	return {
		useDeleteWorkspaceCommand: organizationsWorkspacesCommands.useDeleteWorkspaceCommandV1,
		useUpdateWorkspaceCommand: organizationsWorkspacesCommands.useUpdateWorkspaceCommandV1,
		useWorkspaceDetailsQuery: organizationsWorkspacesQueries.useWorkspaceDetailsQueryV1,
	}
}

export function useManageWorkspacePage(){
	return {
		useAddUserToWorkspaceCommand: organizationsWorkspacesCommands.useAddUserToWorkspaceCommandV1,
		useImportToWorkspaceCommand: organizationsWorkspacesCommands.useImportToWorkspaceCommandV1,
		useInviteToWorkspaceCommand: organizationsWorkspacesCommands.useInviteToWorkspaceCommandV1,
		useRemoveUserFromWorkspaceCommand: organizationsWorkspacesCommands.useRemoveUserFromWorkspaceCommandV1,
		useWorkspaceMembersQuery: organizationsWorkspacesQueries.useWorkspaceMembersQueryV1,
	}
}

